module.exports = __webpack_public_path__ + "img/img10.67631aec.svg";